import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipantService } from 'src/services/participant.service';
import { studyModel, studyScheduleModel, studyRequirementsModel, studyCommitmentModel, screeningScheduleModel } from 'src/models/study.model';
import { participantModel, particpantResponse, disclosure, participantResponseModel, participantStratification, RaceModel } from 'src/models/participant.model';
import { Form, FormGroup, FormArray } from '@angular/forms';
import { questionModel, bindingModel } from 'src/models/question.model';
import { AuthGaurdService } from 'src/services/auth-gaurd.service';
import { AdminService } from 'src/services/admin.service';
import { Location } from '@angular/common';
import { ParticipantDynamicValuesModel } from 'src/app/model/participant.model';
import { WorkflowStore } from 'src/app/store/participant-data/workflow.store';
import { StringHelper } from 'src/Utilities/utility';
import { ConfigService } from 'src/services/config.service';
import { ConsentItem } from 'src/models/consent.model';
import { AppConfig } from 'src/app/app.config';
import { SHARED_IMPORTS } from '../shared.module';
import { SharedDatepickerComponent } from '../../shared/shared-datepicker/shared-datepicker.component';

@Component({
  selector: 'app-shared-participantstudydetail',
  templateUrl: './participant_study_detail.component.html',
  styleUrls: ['./participant_study_detail.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS,SharedDatepickerComponent]
})

export class ParticipantStudyDetailComponent implements OnInit {
  stringHelper = StringHelper;
  tenantId: string = '';
  frmGrpAns: FormGroup;
  frmAryAns: FormArray;
  participantId: string;
  studyId: string;
  showDemo: boolean = true;
  showDesclosure: boolean = false;
  showScreener: boolean = false;
  studyModel: studyModel;
  particpantResponse = new particpantResponse();
  pRSQuestion = new particpantResponse();
  studySchedule: studyScheduleModel[];
  public ParticipantDynamicModel: ParticipantDynamicValuesModel[] = [];
  studyRequirements: studyRequirementsModel[] = [];
  studyScreeningSchedule: screeningScheduleModel[] = [];
  studyCommitment: studyCommitmentModel[] = [];
  participant = new participantModel();
  questionModel: questionModel[];
  disclosure = new disclosure();
  questionModelbackup: questionModel[];
  participantStratification: participantStratification[] = [];
  index: number;
  questionModelbackupl: number;
  answersl: number;
  maxDate: Date;
  minDate: Date;
  demographicsForm: Form;
  radioAnswerId: String;
  radioAnswerText: string;
  dbquestionId: string;
  yearRange: string;
  pRModel = new participantResponseModel();
  wholeHeight: number;

  private readonly workflowStore = inject(WorkflowStore);
  BMI: number;
  wholeBMI: string;
  qualifyFlag: boolean = false;
  enableBtnFlag: boolean = true;
  enableQABtnFlag: boolean = false;
  dobChecked: boolean = true;
  showStudyScheduleFlag: boolean = false;
  AgeMin: string;
  AgeMax: string;
  BMIMin: string;
  BMIMax: string;
  weightMin: string;
  weightMax: string;
  UserIdLogged: string = "";
  checkedDisclosure: number[] = [];
  selectedAnswer: number[] = [];
  isAdmin: boolean = false;
  public qBind: bindingModel[] = [];
  IsRefered: string = "false";
  stratGroupId: number;
  showDynamicscreen: boolean = false;
  existingParticipantId: number;
  processing: boolean = false;
  raceOptions: RaceModel[] = [];
  consentConfig: string;
  consentConfigValue: string;
  consentItems: ConsentItem[] = [];

  formFieldRefs: any = {};

  emailPattern = "^[A-Za-z0-9._\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$";
  dateReg = "(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-]\d{4}";

  @ViewChild("dobpicker", { static: true }) picker;

  toFormattedDate(iso: string) {
    const date = new Date(iso);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }
  open() {
    this.picker.open();
  }
  constructor(private route: ActivatedRoute, private router: Router, private participateservice: ParticipantService, private cdr: ChangeDetectorRef, private authGaurd: AuthGaurdService, private admin: AdminService, private location: Location, private configService: ConfigService) {
  }

  ngOnInit() {
    this.tenantId = AppConfig.appsettings?.tenantId ?? '';
    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {
        let configModel = this.configService.getConfigModel();
        this.consentConfig = configModel.getConfigkeyname('Consent');
        this.consentItems = this.parseConsentItemsFromJson(this.consentConfig);
        this.cdr.detectChanges();
      }
    });
    //this.initializeConsentCheckboxes()
    this.IsRefered = history.state.IsRefered === true ? "true" : "false";

    this.isAdmin = this.authGaurd.isAdmin.toLowerCase() === "true" ? true : false;
    this.getLogginedUserId();
    this.GetRaceOptions();
    this.yearRange = 1900 + ':' + (new Date().getFullYear());
    this.index = 0;
    this.participantId = '';
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate());
    this.studyId = this.route.snapshot.paramMap.get("studyid");
    /* this.getParticipantDynamicValues();*/
    this.admin.getQSDemographics(parseInt(this.studyId), this.isAdmin, this.IsRefered)
      .subscribe(res => {
        this.qBind = res.sort((a, b) => a.groupId - b.groupId)
        let groupId = Array.from(this.qBind.reduce((m, t) => m.set(t.groupId, t), new Map()).values());
        for (let k = 0; k < groupId.length; k++) {
          this.participantStratification.push(
            {
              age: "Any", weight: "Any", gender: "", bmi: "Any"
            }
          );

          let stratificationList = this.qBind.filter(x => x.groupId === groupId[k].groupId).map(x => Object.assign({}, x));

          for (let l = 0; l < stratificationList.length; l++) {
            switch (stratificationList[l].questionText) {
              case "Age":
                if ((stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) && (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null)) {
                  this.participantStratification[k].age = 'Any';
                }
                else if (stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) {
                  this.participantStratification[k].age = "upto " + stratificationList[l].answer2.split('.')[0];
                }
                else if (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null) {
                  this.participantStratification[k].age = stratificationList[l].answer1.split('.')[0] + '+';
                }
                else {
                  this.participantStratification[k].age = stratificationList[l].answer1.split('.')[0] + "-" + stratificationList[l].answer2.split('.')[0];
                }
                break;
              case "Weight":
                if ((stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) && (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null)) {
                  this.participantStratification[k].weight = 'Any';
                }
                else if (stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) {
                  this.participantStratification[k].weight = "upto " + stratificationList[l].answer2;
                }
                else if (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null) {
                  this.participantStratification[k].weight = stratificationList[l].answer1 + '+';
                }
                else {
                  this.participantStratification[k].weight = stratificationList[l].answer1 + "-" + stratificationList[l].answer2;
                }
                break;
              case "BMI":
                if ((stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) && (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null)) {
                  this.participantStratification[k].bmi = 'Any';
                }
                else if (stratificationList[l].answer1 === "-999.00" || stratificationList[l].answer1 === null) {
                  this.participantStratification[k].bmi = "upto " + stratificationList[l].answer2;
                }
                else if (stratificationList[l].answer2 === "999.00" || stratificationList[l].answer2 === null) {
                  this.participantStratification[k].bmi = stratificationList[l].answer1 + '+';
                }
                else {
                  this.participantStratification[k].bmi = stratificationList[l].answer1 + "-" + stratificationList[l].answer2;
                }
                break;
              case "Gender":
                this.participantStratification[k].gender = stratificationList[l].answer1 === 'B' ? 'Both' : stratificationList[l].answer1 === 'M' ? 'Male' : stratificationList[l].answer1 === 'F' ? 'Female' : '-';
            }
          }
        }
         this.cdr.detectChanges();
      });

    if (this.isAdmin === false || this.IsRefered === "true") {
      this.participateservice.getStudyDetailsForParticipant(this.studyId).subscribe(resp => {
        this.studyModel = resp;
        this.studySchedule = JSON.parse(resp.studySchedule);
        for (let i = 0; i < this.studySchedule.length; i++) {
          if (this.studySchedule[i].followupDays !== '') {
            this.showStudyScheduleFlag = true;
            break;
          }
        }
        this.studyRequirements = JSON.parse(resp.studyRequirements);
        this.studyCommitment = JSON.parse(resp.studyCommitment);
        this.studyScreeningSchedule = JSON.parse(resp.screeningSchedule);
        for (let i = 0; i < this.studyScreeningSchedule.length; i++) {
          let screeningscheduleDays: string[] = this.studyScreeningSchedule[i].screeningscheduleDays.split('|').join(',  ').split(',');
          this.studyScreeningSchedule[i].screeningscheduleDays = screeningscheduleDays.toString();
        }
         this.cdr.detectChanges();
      },
        error => {
          this.router.navigate(['study-not-found'],
            { relativeTo: this.route, skipLocationChange: true });
        }
      );
    }
    else {
      this.participateservice.getStudyDetail(this.studyId).subscribe(resp => {
        this.studyModel = resp;
        this.studySchedule = JSON.parse(resp.studySchedule);
        for (let i = 0; i < this.studySchedule.length; i++) {
          if (this.studySchedule[i].followupDays !== '') {
            this.showStudyScheduleFlag = true;
            break;
          }
        }
        this.studyRequirements = JSON.parse(resp.studyRequirements);
        this.studyCommitment = JSON.parse(resp.studyCommitment);
        this.studyScreeningSchedule = JSON.parse(resp.screeningSchedule);
        for (let i = 0; i < this.studyScreeningSchedule.length; i++) {
          let screeningscheduleDays: string[] = this.studyScreeningSchedule[i].screeningscheduleDays.split('|').join(',  ').split(',');
          this.studyScreeningSchedule[i].screeningscheduleDays = screeningscheduleDays.toString();
        }
         this.cdr.detectChanges();
      },
        error => {
          this.router.navigate(['study-not-found'],
            { relativeTo: this.route, skipLocationChange: true });
        }
      );
    }
    this.participant.studyId = this.studyId;
  }


  private parseConsentItemsFromJson(configString: string): ConsentItem[] {
    if (!configString || configString.trim() === '') {
      console.warn('Consent config string is empty');
      return [];
    }

    try {
      let jsonString = configString.trim();
      // Handle escaped backslash-quotes (\\" -> ")
      jsonString = jsonString.replace(/\\"/g, '"');
      // Handle double-escaped backslashes (\\\ -> \)
      jsonString = jsonString.replace(/\\\\/g, '\\');
      const jsonData = JSON.parse(jsonString);
      if (!Array.isArray(jsonData)) {
        console.warn('Consent config is not a JSON array:', typeof jsonData);
        return [];
      }
      const items: ConsentItem[] = [];
      jsonData.forEach((item, index) => {
        try {
          // Create new ConsentItem and explicitly assign properties from JSON
          const consentItem = new ConsentItem();

          // Assign properties from JSON object
          consentItem.isChecked = item.isChecked ?? false;
          consentItem.consent = item.consent ?? '';
          consentItem.hasChildren = item.hasChildren ?? false;
          consentItem.isRequired = item.isRequired ?? false;

          // Process children if they exist
          if (Array.isArray(item.children) && item.children.length > 0) {
            consentItem.children = item.children.map(child => {
              const childItem = new ConsentItem();
              childItem.isChecked = child.isChecked ?? false;
              childItem.consent = child.consent ?? '';
              childItem.hasChildren = child.hasChildren ?? false;
              childItem.isRequired = child.isRequired ?? false;
              // Process grandchildren if they exist
              if (Array.isArray(child.children) && child.children.length > 0) {
                childItem.children = child.children.map(grandchild => {
                  const grandchildItem = new ConsentItem();
                  grandchildItem.isChecked = grandchild.isChecked ?? false;
                  grandchildItem.consent = grandchild.consent ?? '';
                  grandchildItem.hasChildren = grandchild.hasChildren ?? false;
                  grandchildItem.isRequired = grandchild.isRequired ?? false;
                  return grandchildItem;
                });
              }               
              return childItem;
            });
          }
          items.push(consentItem);
          console.log(`Parsed consent item ${index}:`, consentItem);
        } catch (err) {
          console.warn(`Failed to parse consent item at index ${index}:`, err, item);
        }
      });
      return items;
    } catch (err) {
      console.error('Failed to parse consent config JSON:', err);
      console.error('Config string (first 500 chars):', configString.substring(0, 500));
      return [];
    }
  }

  getParticipantDynamicValues() {
    this.participateservice.getParticipantDynamicValues(this.studyId, this.isAdmin, this.IsRefered)
      .subscribe(res => {
        this.ParticipantDynamicModel = res.filter(x => (x.D_Option && x.D_Option != '' && x.D_Option != '2' && x.stratificationGroupId === this.stratGroupId));
        this.showDynamicscreen = res.some(x => x.stratificationGroupId === this.stratGroupId);
        if (!this.showDynamicscreen) {
          this.navigateCriteria();
          this.showDemo = false;
        }
        this.cdr.detectChanges();
      });
  }

  buttonEnable(event) {
    if (this.questionModelbackup[this.index].questionDesc.trim() !== '' && this.questionModelbackup[this.index].questionDesc !== null) {
      this.enableQABtnFlag = true;
    }
    else {
      this.enableQABtnFlag = false;
    }
  }

  getLogginedUserId() {
    this.admin.getUserId()
      .subscribe(response => {
        this.UserIdLogged = String(response);
      });
  }

  cancel() {
    this.router.navigate(['/adminhome/studydetail/', this.studyId], { fragment: 'display', skipLocationChange: true });
  }
  onChangeQA(event, answerId) {
    if (event && answerId) {
      this.enableQABtnFlag = true;
    }

    else {
      this.enableQABtnFlag = false;
    }
  }

  onChangeFreeTxt(event, answerType) {
    if (answerType !== 'Radio-Text')
      this.enableQABtnFlag = event.target.value !== '';
  }
  checkInch() {
    if (!this.participant.inches) {
      this.participant.inches = 0;
    }
  }
  calculateBMI() {
    if ((this.participant.height !== null && this.participant.height > 0) && (this.participant.inches !== null) && (this.participant.weight !== null && this.participant.weight > 0)) {
      this.wholeHeight = (this.participant.height * 12) + this.participant.inches;
      this.BMI = ((this.participant.weight / Math.pow(this.wholeHeight, 2)) * 703);
      this.wholeBMI = this.BMI.toFixed(2);
    }
    else {
      this.wholeBMI = '';
    }
  }

  // Mark a checkbox as touched for validation purposes
  markCheckboxTouched(checkboxId: string): void {
    this.formFieldRefs[checkboxId] = {
      ...(this.formFieldRefs[checkboxId] || {}),
      touched: true
    };
  }

  // Utility to check if a checkbox has been interacted with for validation purposes
  isCheckboxTouched(checkboxId: string): boolean {
    return this.formFieldRefs[checkboxId]?.touched || false;
  }

  getConsentItemKey(parentIndex: number, childIndex?: number): string {
    return childIndex !== undefined ? `consent-${parentIndex}-${childIndex}` : `consent-${parentIndex}`;
  } 

  getConsentItemLabel(item: ConsentItem): string {
      return item?.consent || '';
  } 
  hasRequiredConsentError(item: ConsentItem, key: string): boolean {
    return !!item?.isRequired && !item?.isChecked && this.isCheckboxTouched(key);
  }

  hasContactChildren(item: ConsentItem): boolean {
    return !!item?.hasChildren && Array.isArray(item.children) && item.children.length > 0;
  }

  //For the Phone, Email, SMS contact checkboxes - at least one must be selected if not then show validation message. 
  isAtLeastOneContactMethodSelected(): boolean {
    return this.consentItems.some(item =>
      this.hasContactChildren(item) && item.children.some(child => child.isChecked)
    );
  }

  //Checks interaction with any of the contact method checkboxes to trigger validation message if none are selected
  isAnyContactMethodTouched(): boolean {
    return this.consentItems.some((item, parentIndex) =>
      this.hasContactChildren(item) && item.children.some((child, childIndex) =>
        this.isCheckboxTouched(this.getConsentItemKey(parentIndex, childIndex))
      )
    );
  }

  // Get appropriate error message for a checkbox based on its configuration and validation state
  getCheckboxErrorMessage(hasChildren: boolean = false): string {
    if (hasChildren) {
      return 'At least one contact method must be checked';
    }
    return 'Required to check this box';
  }

  navigateCriteria(): void {
    if (!this.particpantResponse.participantResult && this.particpantResponse.questionType === 'Demographics') {
      this.router.navigate(['ParticipantDisqualifyDemographic'], { relativeTo: this.route, skipLocationChange: true });
      this.qualifyFlag = true;
       this.cdr.detectChanges();
    }
    else {
      this.showDemo = false;
      this.showDesclosure = false;
      this.showScreener = false;
      this.getDisclosure();
      this.Disclosure();
      this.cdr.detectChanges();
    }
  }
  getDisclosure(): void {
    this.participateservice.getDisclosure().subscribe(resp => {
      this.questionModel = resp;
    });
  }
  formatDate() {
    var longdate = this.participant.dob;
    var date = new Date(longdate);
    var day = date.getDate();
    var mon = date.getMonth() + 1;
    var yea = date.getFullYear();
    var shortdate = mon + '/' + day + '/' + yea;
    this.participant.dob = shortdate;
  }

  Demographics(event): void {
    this.enableBtnFlag = false;
    event.preventDefault();
    event.stopPropagation();
    this.formatDate();

    const contactGroup = this.consentItems.find(item => this.hasContactChildren(item));
    this.participant.phoneContact = !!contactGroup?.children?.some(child => child.isChecked && child.consent.toLowerCase().includes('phone'));
    this.participant.emailContact = !!contactGroup?.children?.some(child => child.isChecked && child.consent.toLowerCase().includes('email'));
    this.participant.smsContact = !!contactGroup?.children?.some(child => child.isChecked && child.consent.toLowerCase().includes('sms'));

    let _participant: participantModel = new participantModel();
    _participant.studyId = this.participant.studyId;
    _participant.firstName = this.participant.firstName;
    _participant.lastName = this.participant.lastName;
    _participant.dob = this.participant.dob;
    _participant.emailId = this.participant.emailId;
    _participant.phone = this.participant.phone;
    _participant.gender = this.participant.gender;
    _participant.height = parseFloat(this.participant.height + "." + this.participant.inches);
    _participant.weight = this.participant.weight;
    _participant.wristCircumference = this.participant.wristCircumference;
    _participant.allowMessage = this.participant.smsContact;
    _participant.allowPhone = this.participant.phoneContact;
    _participant.allowEmail = this.participant.emailContact;
    _participant.middleInitial = this.participant.middleInitial;
    _participant.RaceId = this.participant.RaceId;
    if (this.IsRefered === "true") {
      _participant.isMock = false;
      _participant.adminId = this.UserIdLogged;
    }
    else {
      _participant.isMock = this.isAdmin;
      _participant.adminId = "0";
    }
    _participant.bmi = parseFloat(this.wholeBMI);
    _participant.dynamicvalues = this.ParticipantDynamicModel;
    _participant.createdBy = this.UserIdLogged;
    _participant.modifiedBy = this.UserIdLogged;
    this.participateservice.postDemographics(_participant).subscribe(resp => {
      this.particpantResponse = resp;
      this.stratGroupId = this.particpantResponse.stratificationGroupId;
      this.existingParticipantId = this.particpantResponse.participantId;
      if (this.particpantResponse.attemptNumber > 4) {
        alert("You have reached the maximum number of attempts for this study.");
      }
      else if (this.particpantResponse.participantResult) {
        this.getParticipantDynamicValues();
        this.showDemo = false;
      }
      else {
        this.navigateCriteria();
        this.showDemo = false;
      }
      this.cdr.detectChanges();
    });
  }

  Dynamics(event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.processing) return;
    this.processing = true;
    this.formatDate();

    let _participant: participantModel = new participantModel();
    _participant.gender = this.participant.gender;
    if (this.IsRefered === "true") {
      _participant.isMock = false;
      _participant.adminId = this.UserIdLogged;
    }
    else {
      _participant.isMock = this.isAdmin;
      _participant.adminId = "0";
    }
    let processedDynamicValues = this.ParticipantDynamicModel?.map(item => {
      if (item.D_Option && typeof item.D_Option === 'string') {

        let cleanedOption = item.D_Option.replace(/\s*\(inches\)\s*/gi, '');
        return {
          ...item,
          D_Option: cleanedOption
        };
      }
      return item;
    }) || [];
    _participant.participantId = this.existingParticipantId;
    _participant.stratGroupId = this.stratGroupId;
    _participant.studyId = this.participant.studyId;
    _participant.dynamicvalues = processedDynamicValues;
    this.participateservice.postDynamics(_participant).subscribe(resp => {
      this.particpantResponse = resp;
      this.processing = false;
      this.showDemo = false;
      this.showDynamicscreen = false;
      this.navigateCriteria();
      this.cdr.detectChanges();
    });
  }
  areDynamicInputsValid(): boolean {
    return this.ParticipantDynamicModel.every(d => d.D_Value != null && d.D_Value !== undefined && d.D_Value.toString().trim()! == '');
  }
  Disclosure(): void {
    this.enableBtnFlag = false;
    this.getQuestions();
    this.showDemo = false;
    this.showDesclosure = false;
    this.showDynamicscreen = false;
    this.showScreener = true;

    this.disclosure.participantId = this.particpantResponse.participantId;
    this.disclosure.studyId = Number(this.studyId);
    this.disclosure.disclosurePass = true;
    this.disclosure.Is_Active = true;
    this.disclosure.attemptNumber = this.particpantResponse.attemptNumber;

    if (!this.isAdmin) {
      this.participateservice.postDisclosure(this.disclosure).subscribe(
        resp => {
          resp
        }
      );
    } 
  }
  getQuestions() {
    this.participateservice.getQuestions(this.studyId, this.isAdmin, this.IsRefered).subscribe(resp => {
      this.questionModelbackup = resp.sort((a, b) => { return a.questionOrder - b.questionOrder; });
      this.questionModelbackupl = this.questionModelbackup.length;
      this.answersl = this.questionModelbackup[this.index].answers.length;
      this.cdr.detectChanges();
    });
  }
  Screener() {
    this.enableQABtnFlag = false;
    this.questionModelbackupl = this.questionModelbackup.length;

    if (this.questionModelbackupl) {
      this.pRModel.participantId = this.particpantResponse.participantId;
      this.pRModel.attemptNumber = this.particpantResponse.attemptNumber;
      this.pRModel.questionOrder = this.index + 1;
       
      if (this.questionModelbackup[this.index].answerType === "Radio") {
        this.pRModel.questionId = Number(this.questionModelbackup[this.index].questionDesc.split('|')[0]);
        this.pRModel.answerId = Number(this.questionModelbackup[this.index].
          questionDesc.split('|')[1]);
        this.pRModel.answerText = this.questionModelbackup[this.index].questionDesc.split('|')[2];         
      } else if (this.questionModelbackup[this.index].answerType === "Text") {
        this.pRModel.questionId = this.questionModelbackup[this.index].questionId;
        this.pRModel.answerText = this.questionModelbackup[this.index].freeText;
        this.pRModel.answerId = Number(this.questionModelbackup[this.index].answers[0].answerId);        
      }
      else {
        this.pRModel.questionId = this.questionModelbackup[this.index].questionId;
        this.pRModel.answerText = this.questionModelbackup[this.index].questionDesc.split('|')[2];
        this.pRModel.answerId = Number(this.questionModelbackup[this.index].answers[0].answerId);        
      }
      this.pRModel.studyId = Number(this.studyId);
      this.pRModel.freeText = this.questionModelbackup[this.index].freeText;
      this.pRModel.questionCategory = "PreScreener";
      if (this.pRModel.answerText !== undefined && this.pRModel.answerText.trim() !== '') {
        if (this.isAdmin === true && this.IsRefered === "false") {
          this.participateservice.postmockPreScreenerQA(this.pRModel).subscribe(resp => {
            this.pRSQuestion = JSON.parse(resp);
            if (this.pRSQuestion.participantResult) {
              this.index += 1;

              if (this.index === this.questionModelbackupl) {
                this.workflowStore.setParticipantData(
                  this.pRModel.participantId.toString(),
                  this.pRModel.attemptNumber
                );
                this.router.navigate(['ParticipantQualify'], { relativeTo: this.route, skipLocationChange: true });
                this.showScreener = false;
                this.qualifyFlag = true;
              }
            }
            else if (!this.pRSQuestion.participantResult && this.pRSQuestion.questionType === 'PreScreener') {
              this.router.navigate(['ParticipantDisqualify'], { relativeTo: this.route, skipLocationChange: true });
              this.showScreener = false;
              this.qualifyFlag = true;
            }
          });          
        }
        else {
          this.participateservice.postPreScreenerQA(this.pRModel).subscribe(resp => {
            this.pRSQuestion = JSON.parse(resp);              
            if (this.pRSQuestion.participantResult) {
              this.index += 1; 

              if (this.index === this.questionModelbackupl) {
                this.workflowStore.setParticipantData(
                  this.pRModel.participantId.toString(),
                  this.pRModel.attemptNumber
                );
                this.router.navigate(['ParticipantQualify'], { relativeTo: this.route, skipLocationChange: true });
                this.showScreener = false;
                this.qualifyFlag = true;                 
              }
              this.cdr.detectChanges();
            }
            else {
              this.router.navigate(['ParticipantDisqualify'], { relativeTo: this.route, skipLocationChange: true });
              this.showScreener = false;
              this.qualifyFlag = true;
               this.cdr.detectChanges();
            }
          });          
        }
      }
      this.showDemo = false;
      this.showDesclosure = false;
      this.showScreener = true; 
      this.cdr.detectChanges();
    }
  }
  onChangefd(event, quesId) {
    if (event) {
      this.checkedDisclosure.push(quesId);
    }
    else {
      let index = this.checkedDisclosure.findIndex(x => x === quesId);

      if (index >= 0) {
        this.checkedDisclosure.splice(index, 1);
      }
    }
    this.enableBtnFlag = (this.checkedDisclosure.length === this.questionModel.length);
  }


  numberOnly(event) {
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;

    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  numberAndHypen(event) {
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;

    return !(charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45);
  }

  formatPhoneNumber(event: Event): void {
    let input = event.target as HTMLInputElement;
    let numbers = input.value.replace(/\D/g, '');
    if (numbers.length > 10) {
      numbers = numbers.substring(0, 10);
    }
    let parts = [];
    if (numbers.length > 3) {
      parts.push(numbers.substring(0, 3));
      if (numbers.length > 6) {
        parts.push(numbers.substring(3, 6));
        parts.push(numbers.substring(6, 10));
      } else {
        parts.push(numbers.substring(3));
      }
    } else {
      parts.push(numbers);
    }
    this.participant.phone = parts.join('-');
    input.value = this.participant.phone;
  }

  limitInputLength(event: Event, maxLength: number) {
    let element = event.target as HTMLInputElement;
    if (element.value.length > maxLength) { element.value = element.value.slice(0, maxLength); }
  }

  numberwithdecimalOnly(event) {
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onBlurMethod(event) {
    this.dobChecked = true;
    if (event.length !== 10 && event.length !== 8 && event.length !== 9 && event.length !== 0) {
      this.dobChecked = false;
    }
    let date = event.split('/');

    for (let i = 0; i < date.length; i++) {
      if (i === 0 && (isNaN(Number(date[i])) || Number(date[i]) === 0 || Number(date[i]) > 12)) {
        this.dobChecked = false;
        break;
      }
      if (i === 1 && (isNaN(Number(date[i])) || Number(date[i]) === 0 || Number(date[i]) > 31)) {
        this.dobChecked = false;
        break;
      }
      if (i === 2 && (isNaN(Number(date[i])) || Number(date[i]) === 0 || Number(date[i]) < 1900 || Number(date[i]) > this.maxDate.getFullYear())) {
        this.dobChecked = false;
      }
      if (i === 2 && Number(date[2] === this.maxDate.getFullYear())) {
        if (Number(date[0]) > this.maxDate.getMonth() + 1) {
          this.dobChecked = false;
          break;
        }
        else if (Number(date[1]) > this.maxDate.getDate()) {
          this.dobChecked = false;
          break;
        }
      }
    }
  }

  GetRaceOptions() {
    this.participateservice.GetRaceOptions()
      .subscribe(_s => this.raceOptions = _s);
  }

  hasMissingRequiredConsent(): boolean {
    return this.consentItems.some(item => {
      if (!item?.isRequired) return false;
      // required group with children: at least one child must be checked
      if (this.hasContactChildren(item)) {
        return !item.children?.some(child => !!child.isChecked);
      }
      // required single checkbox
      return !item.isChecked;
    });
  }
}
